import {
	ControlEventTypes as DMSControlEventTypes,
	GridEventTypes as DMSGridEventTypes,
} from "./index";

/**
 * ## Event types
 * List of all event types.
 *
 * Please use the links below to navigate to the documentation of each event type.
 */
export namespace Events {
	
	/**
	 * Click {@link ControlEventTypes|here} for the documentation of EventTypes.
	 */
	export const ControlEventTypes = DMSControlEventTypes;
	
	/**
	 * Click {@link GridEventTypes|here} for the documentation of GridEventTypes.
	 */
	export const GridEventTypes = DMSGridEventTypes;
}
